import { render, staticRenderFns } from "./CollectionPage.vue?vue&type=template&id=ecea50de&scoped=true"
import script from "./CollectionPage.vue?vue&type=script&lang=js"
export * from "./CollectionPage.vue?vue&type=script&lang=js"
import style0 from "./CollectionPage.vue?vue&type=style&index=0&id=ecea50de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecea50de",
  null
  
)

export default component.exports